import React from 'react';
import Link from './Link';

const LinkList = (props) => {
  const { links, classes } = props;

  return (
    <ul className={`link-list ${classes ? classes : ''}`}>
      {links.map((link, index) => {
        if (link && link.link) {
          return (
            <li key={index} className="link-list__item">
              <Link to={link.link} target={link.target}>
                {link.title}
              </Link>
            </li>
          );
        }
      })}
    </ul>
  );
};

export default LinkList;
